"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Toggle.scss");
var key_press_1 = require("../../../utils/key-press");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (e) {
            if (enterIsPressed(e)) {
                _this.handleClick(e);
                _this.onChange(e);
            }
        };
        _this.handleClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.data.value, e);
            }
        };
        _this.onChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(_this.props.data.value, e);
            }
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            return (React.createElement("label", { "data-testid": testId, className: styles.toggleLabel + " " + _this.props.className },
                React.createElement("input", { id: _this.labelId, "aria-label": data.text, ref: function (inputElement) { return (_this.inputEl = inputElement); }, checked: _this.props.data.value, "aria-checked": _this.props.data.value ? true : false, className: styles.toggleCheckbox, onChange: _this.onChange, onClick: _this.handleClick, disabled: options.disabled ? true : undefined, onKeyDown: _this.handleKeyPress, role: "switch", type: "checkbox" }),
                React.createElement("span", { "aria-hidden": true, className: _this.props.data.value
                        ? styles.toggleMsgOn +
                            " " +
                            (data.rightAlign ? " text-right" : " text-left")
                        : styles.toggleMsgOff + (data.rightAlign ? " text-right" : " text-left") }, _this.props.data.value ? "ON" : "OFF"),
                React.createElement("div", { className: _this.props.data.value
                        ? styles.toggleSwitch + " " + data.type
                        : styles.toggleSwitch },
                    React.createElement("span", { className: styles.toggleHandle }))));
        };
        _this.labelId = _this.guid();
        return _this;
    }
    Toggle.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    Toggle.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    Toggle.defaultProps = {
        data: {
            text: "",
            type: "",
            value: false,
            rightAlign: true,
        },
        options: {
            disabled: false,
        },
    };
    return Toggle;
}(React.PureComponent));
exports.default = Toggle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Toggle/Toggle.js
// module id = 1827
// module chunks = 8